import type { VFC } from 'react';

import { VulnReachability } from '../../../../../shared/issuesV2';
import { CheckboxFilterGroup, FilterPanel } from '../../../generic/Filter';
import type { SelectedOptionsProps } from '../../../generic/Filter';

const FILTER_OPTIONS: Array<{ key: VulnReachability, label: string }> = [
  { key: VulnReachability.ReachableFunctions, label: 'Reachable functions' },
  { key: VulnReachability.VulnerableFunctions, label: 'Vulnerable functions available' },
];

/**
 * Add a series of checkboxes for filtering Vuln Issues by "Exploit Maturity".
 */
const ReachabilityFilter: VFC<SelectedOptionsProps> = ({ selectedOptions, onSelect }) => (
  <FilterPanel>
    <CheckboxFilterGroup
      title="Reachability"
      options={FILTER_OPTIONS}
      selectedOptions={selectedOptions}
      onSelect={onSelect}
      testId="issues-vuln-reachability"
  />
  </FilterPanel>
);

export default ReachabilityFilter;
